module.exports = __webpack_public_path__ + "media/app_search/FreeTrialExtend/images/clients/client-icon-ruby-a3fdc39e66bd292b0300b392e7dbe4f8.svg";